import React from "react";

import style from "./Spinner.scss";

export default function Spinner(props)
{
    return <div className={ [ style.spinner, props.isInline ? style.inline : "" ].join(' ')}>
        <div className={style.dot1} />
        <div className={style.dot2} />
    </div>
}